export default __webpack_public_path__ + "static/media/slide-4.7988c602.jpeg";